App.DeliveryCouriersController = Em.Controller.extend
  restaurants: []
  couriersBinding: 'deliveryCouriers'

  env: Em.inject.service('environment')

  transportsEnabled: Em.computed.alias('env.features.externalTransports')
  transportsDisabled: Em.computed.not('transportsEnabled')

  deliveryCouriers: (->
    return null unless @get('model.couriers')

    return @get('model.couriers').filter(-> true).sort((a,b) ->
      return 1 if a.get('disabled') and !b.get('disabled')
      return -1 if b.get('disabled') and !a.get('disabled')
      return 0
    )
  ).property('model.couriers')
